import { styled, theme } from 'ui/theme';

import type { IconSizes } from './Icon.d';

const StyledIcon = styled.svg<{ size: IconSizes }>`
  align-items: center;
  display: flex;
  height: initial;
  width: ${({ size }) => theme.iconSizes[size]};

  path {
    fill: currentColor;
  }
`;

export default StyledIcon;
